<template>
    <div class="app_container">
        <div></div>
    </div>
</template>

<script>
  export default {
    name: "index",
  };
</script>

<style scoped>

</style>
